import { render, staticRenderFns } from "./ClassesMian.vue?vue&type=template&id=57ca1e14&scoped=true"
import script from "./ClassesMian.vue?vue&type=script&lang=js"
export * from "./ClassesMian.vue?vue&type=script&lang=js"
import style0 from "./ClassesMian.vue?vue&type=style&index=0&id=57ca1e14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57ca1e14",
  null
  
)

export default component.exports